module.exports = __webpack_public_path__ + "static/assets/42f568ea43bc3ccb3de1c575cfc04484.svg";